export class SelectSelectModel {
  label?: string;
  labelClass?: string;
  error?: string;
  multiple?: boolean;

  constructor( obj: {
    label?: string,
    labelClass?: string,
    error?: string;
    multiple?: boolean
  } | any = {} ) {
    const ob = obj ? obj : {};

    this.label = ob && ob.label ? ob.label : '';
    this.labelClass = ob && ob.labelClass ? ob.labelClass : '';
    this.error = ob && ob.error ? ob.error : '';
    this.multiple = ob && ob.multiple !== undefined ? ob.multiple : false;
  }
}
